import { TableColumn, TableRow } from '@/components/Table/types';
import { Trans } from 'react-i18next';

type StageColumnConfig<T extends TableRow> = {
  options?: Omit<TableColumn<T>, 'id' | 'label'>;
};

export const stageColumnConfig = <T extends TableRow>({
  options,
}: StageColumnConfig<T> = {}): TableColumn<T> => ({
  id: 'stage',
  label: <Trans i18nKey="stage" />,
  render: (value) => (
    <div className="overflow-hidden text-ellipsis">{value}</div>
  ),
  acessorKey: 'stage',
  sortable: true,
  className: 'max-w-[20vw] w-[20vw]',
  ...options,
});
